export function generateRFQRouterStr(rfqId: number) {
  return `/workspace/RFQ?rfqId=${rfqId}`;
}

export function generateProjectRouterStr(projectId?: string) {
  const projectsUrl = '/projects';
  return projectId ? `${projectsUrl}/${projectId}` : projectsUrl;
}
